import { useState, useMemo } from "react";
import { useCoinlist } from "../../context/CoinlistContext";
import CoinModal from "../CoinModal";

export default function SearchBar() {
  const { coins } = useCoinlist();
  const [query, setQuery] = useState("");
  const [selectedSymbol, setSelectedSymbol] = useState(null);

  const results = useMemo(() => {
    if (!query.trim()) return [];
    const q = query.toLowerCase();
    return coins
      .filter(c =>
        c.name.toLowerCase().includes(q) ||
        c.symbol.toLowerCase().includes(q)
      )
      .slice(0, 10);
  }, [query, coins]);

  function handleSelect(symbol) {
    console.log("CLICKED:", symbol);   // <‑‑ add this line
    setQuery("");
    setSelectedSymbol(symbol);
  }

  return (
    <div className="search-bar">
      <span className="search-icon">🔍</span>
      <input
        type="text"
        placeholder="Search coins…"
        value={query}
        onChange={e => setQuery(e.target.value)}
        className="search-input"
      />

      {query && results.length > 0 && (
        <ul className="search-results">
          {results.map(coin => (
            <li key={coin.symbol} onClick={() => handleSelect(coin.symbol)}>
              <span className="symbol">{coin.symbol.toUpperCase()}</span>
            </li>
          ))}
        </ul>
      )}

      {/* Modal must be OUTSIDE the <ul> */}
      {selectedSymbol && (
        <CoinModal
          symbol={selectedSymbol}
          onClose={() => setSelectedSymbol(null)}
        />
      )}
    </div>
  );
}
